export default __webpack_public_path__ + "static/media/pic6.b99d39b8.jpg";